import { Component } from '@angular/core';

@Component({
  selector: 'app-tos',
  imports: [],
  templateUrl: './tos.component.html',
  styleUrl: './tos.component.scss'
})
export class TosComponent {

}
